define((require) => {
    "use strict";

    const AnimationController = require("shared/ui/experience/widgets/animations/AnimationController");
    const Preconditions       = require("shared/util/Preconditions");

    /**
     * The animation controller for a slide animation.
     *
     * @class SlideOutAnimationController
     * @constructor
     */
    return AnimationController.extend({

        /**
         * @inheritDoc
         */
        type: AnimationController.Type.OUTRO, // We're sliding out, hence "outro"

        descriptor() {
            const appearanceDescriptor = this.getAppearanceDescriptor();
            const scaledExperienceSize = this.unscaledExperienceSize.scale(appearanceDescriptor.scale);
            const stylingRect = appearanceDescriptor.styling;
            const toPoint = {};
            const direction = this.animationModel.get("direction");

            switch (direction) {
                case "top":
                    toPoint.y = -this.elementBounds.height - Math.max(0, stylingRect.height + stylingRect.y);
                    break;

                case "left":
                    toPoint.x = -this.elementBounds.width - Math.max(0, stylingRect.width + stylingRect.x);
                    break;

                case "bottom":
                    toPoint.y = scaledExperienceSize.height + appearanceDescriptor.pivotOffset.height + Math.max(0, stylingRect.height - stylingRect.y);
                    break;

                case "right":
                    toPoint.x = scaledExperienceSize.width + appearanceDescriptor.pivotOffset.width + Math.max(0, stylingRect.width - stylingRect.x);
                    break;

                default:
                    // TODO Candidate for refactoring during MOS-2934.
                    Preconditions.warn(`DefaultSwitchWarn - Direction '${direction}' not recognized.`);
                    break;
            }

            return {
                to: toPoint
            };
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/animations/slideOut/SlideOutAnimationController.js